export default __webpack_public_path__ + "static/media/real-life-RIM.5a2ab747.mp3";